module.exports = __webpack_public_path__ + "img/1.b074018c.png";